import React, { useState } from 'react';
import { VERSION_INFO } from '../version';

interface VersionInfoComponentProps {
  className?: string;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  expandable?: boolean;
}

export const VersionInfo: React.FC<VersionInfoComponentProps> = ({
  className = '',
  position = 'bottom-right',
  expandable = false
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const positionClasses = {
    'bottom-right': 'fixed bottom-4 right-4',
    'bottom-left': 'fixed bottom-4 left-4', 
    'top-right': 'fixed top-4 right-4',
    'top-left': 'fixed top-4 left-4'
  };

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleString('tr-TR', {
        day: '2-digit',
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  if (!expandable) {
    return (
      <div className={`${positionClasses[position]} ${className}`}>
        <div className="bg-gray-800 text-white px-2 py-1 rounded text-xs font-mono opacity-75 hover:opacity-100 transition-opacity">
          v{VERSION_INFO.version}
        </div>
      </div>
    );
  }

  return (
    <div className={`${positionClasses[position]} ${className} z-50`}>
      <div className="bg-gray-800 text-white rounded shadow-lg">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="px-2 py-1 text-xs font-mono opacity-75 hover:opacity-100 transition-opacity w-full text-left text-gray-900"
        >
          v{VERSION_INFO.version}
        </button>
        
        {isExpanded && (
          <div className="border-t border-gray-600 p-3 text-xs space-y-1 min-w-64">
            <div className="flex justify-between">
              <span className="text-gray-400">Version:</span>
              <span className="font-mono">{VERSION_INFO.version}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Git Hash:</span>
              <span className="font-mono">{VERSION_INFO.gitHash}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Branch:</span>
              <span className="font-mono">{VERSION_INFO.gitBranch}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Build Time:</span>
              <span className="font-mono text-xs">{formatDate(VERSION_INFO.buildTime)}</span>
            </div>
            {VERSION_INFO.gitDate !== 'unknown' && (
              <div className="flex justify-between">
                <span className="text-gray-400">Last Commit:</span>
                <span className="font-mono text-xs">{formatDate(VERSION_INFO.gitDate)}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default VersionInfo;
